import { render, staticRenderFns } from "./Performers.vue?vue&type=template&id=7f530f22&scoped=true&"
import script from "./Performers.vue?vue&type=script&lang=js&"
export * from "./Performers.vue?vue&type=script&lang=js&"
import style0 from "./Performers.vue?vue&type=style&index=0&id=7f530f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f530f22",
  null
  
)

export default component.exports